<template>
    <div class="grid grid-cols-3 gap-4 my-6">
      <div class="text-center">
        <div class="text-2xl font-bold text-primary">+7</div>
        <div class="text-sm text-gray-600">Anos de Experiência</div>
      </div>
      <div class="text-center">
        <div class="text-2xl font-bold text-primary">+3 mil</div>
        <div class="text-sm text-gray-600">Clientes</div>
      </div>
      <div class="text-center">
        <div class="text-2xl font-bold text-primary">+20 mil</div>
        <div class="text-sm text-gray-600">Seguidores</div>
      </div>
    </div>
  </template>